import React from "react";
import styled from "styled-components";
import PretendardText from "./../text/pretendardText";

const BlueBtn = (props) => {
  return (
    <StyledBlueBtn
      style={{
        ...props.style,
      }}
      onClick={props.onClick}
    >
      <PretendardText
        style={{
          color: "#27beff",
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "22.75px",
          textAlign: "center",
        }}
      >
        {props.children}
      </PretendardText>
    </StyledBlueBtn>
  );
};

export default BlueBtn;

const StyledBlueBtn = styled.button.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid #27beff;
  background-color: inherit;
`;
